import { useStyles } from "../context";
import {
  CoreAirPriceWatchComponent,
  CORE_AIR_PRICE_WATCH_NAME,
} from "@b2bportal/core-types";

export const useAirPriceWatchStyles = (
  componentName: keyof typeof CoreAirPriceWatchComponent,
  defaultStyles?: object
) => {
  return useStyles(CORE_AIR_PRICE_WATCH_NAME, componentName, defaultStyles);
};
